import { render, staticRenderFns } from "./InvoiceEmailEdit.vue?vue&type=template&id=5f5780fc"
import script from "./InvoiceEmailEdit.vue?vue&type=script&lang=ts"
export * from "./InvoiceEmailEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports